/**
 * @ngdoc    directive
 * @name     csm.ui.validators.directive:textValidator
 * @restrict A
 * @param    {string=} textValidator    Error popup title.
 * @param    {string=} csmRequired      "false"=value is not required.
 * @param    {string=} disableValidator "true"=skip validation.
 * @param    {string=} min              Minimum character length.
 * @param    {string=} max              Maximum character length.
 *
 * @description
 * Validator to verify a text input value with length restrictions.
 **/
/* @ngInject */
export function textValidator(CSMValidatorService) {
  return CSMValidatorService.makeDirective({
    doValidate: function (value) {
      var error = CSMValidatorService.BaseValidator.prototype.doValidate.call(
        this,
        value
      );
      if ((!error && value != undefined) || value != null) {
        var length = value.length;
        var minLength = (this.attributes.min || '').parseNumber();
        var maxLength = (this.attributes.max || '').parseNumber();

        if (!isNaN(minLength) && length < minLength)
          error = 'This needs to be at least {0} characters'.format(minLength);

        if (!isNaN(maxLength) && length > maxLength)
          error =
            'This has exceeded the maximum length of {0} characters'.format(
              maxLength
            );
      }
      return error;
    }
  });
}
